export const QCAL_INITIAL_VIEW_KEY = 'qwealth_cal_initial_view';
export const SHARED_CALENDAR_KEY = 'shared_calendars';
export const ORGANIZER_LIST_KEY = 'organizer_list';
